import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Auth from '../helpers/Auth';
import { Navbar, NavDropdown, MenuItem, Image } from 'react-bootstrap';
import { connect } from 'react-redux'

import logo from '../logo-white.png'

class Header extends Component {

  componentDidUpdate() {
    if (this.props.user == null && window.location.pathname !== '/') {
      return window.location.href = '/';
    }
  }

  render() {
    const { user } = this.props
    return <Navbar inverse>
      <Navbar.Header style={{float: 'left'}}>
        <Navbar.Brand>
          <Link to="/">
            <img src={logo} alt="logo" className="logo" />
          </Link>
        </Navbar.Brand>
      </Navbar.Header>
      { user ? (
        <NavDropdown pullRight style={{float: 'right', lineHeight: '50px'}} eventKey={1}
          title={
            <div style={{ color: '#eee', display: 'inline-block' }}>
              <Image className="thumbnail-image"
                circle
                style={{ margin: '-5px 10px 0 0', display: 'inline-block' }}
                height="30px"
                src={user.photoURL}
                alt="user pic"
              />
              {user.name}
            </div>
          }
          id="basic-nav-dropdown"
        >
          <MenuItem eventKey={1.2} onClick={Auth.signOut}>
            Sign Out
          </MenuItem>
        </NavDropdown>
      ) : null }
    </Navbar>
  }
}

const mapStateToProps = (state) => {
  const { user } = state.auth;
  return { user };
}

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js